import { styles } from './template.scss';
import { styles as textHelpersStyles } from '../../assets/text-helpers.scss';

export const templateDashboardApp = document.createElement('template');

templateDashboardApp.innerHTML = `
  <style>${styles}</style>
  <style>${textHelpersStyles}</style>

  <div class="wrapper">
     <div class="dashboards-header">
        <h1 class="title display-1"></h1>
    </div>

    <div class="dashboards grid"></div>

    <gz-image-repo state="error" class="dashboard-error">
        <gz-text fontSize="14" fontWeight="400" class="dashboard-error--message" lineHeight="1.2"/>
    </gz-image-repo>

    <gz-image-repo state="empty" class="dashboard-empty">
        <gz-text fontSize="14" fontWeight="400" class="dashboard-empty--message" lineHeight="1.2"/>
    </gz-image-repo>

    <gz-dashboard-loading-screen class="dashboard-loader"></gz-dashboard-loading-screen>
  </div>
`;
